import * as requests from '../requests/analytics'

export const FETCH_AQI = 'FETCH_AQI'
export const FETCH_HISTORIC_AQI = 'FETCH_HISTORIC_AQI'
export const REMOVE_AQI = 'REMOVE_AQI'
export const STOP_TIMEOUT = 'STOP_TIMEOUT'
export const SAVE_TIMEOUT = 'SAVE_TIMEOUT'


export const getAqi = (coords, timestamp) => {
    return (dispatch,getState) => {
        if (!getState().slider.isLooping) {
            dispatch(fetchHistoric(coords))
            dispatch(fetchAqi(coords, timestamp))
        }
    }
}

export const fetchAqi = (coords, timestamp) => {
    return (dispatch, getState) => {
            requests.getAQI(coords, timestamp, aqi => {
                dispatch({
                    type: FETCH_AQI,
                    aqi
                })
            })

    }
}
export const deleteAllAQIHist = (map) =>{
        requests.deleteAllAQIHistory(map)

}

export const fetchHistoric = (coords) => {
    return dispatch => {
        requests.getAQIHistory(coords, historic => {
            dispatch({
                type: FETCH_HISTORIC_AQI,
                historic
            })
        })
    }
}

export const removeAQI = () => {
    return {
        type: REMOVE_AQI
    }
}

export const saveTimeout = (timeout) => {
    return {
        type: SAVE_TIMEOUT,
        timeout
    }
}

export const stopTimeout = () => {
    return {
        type: STOP_TIMEOUT
    }
}

export const updateAQI = (timestamp, timeout) => {
    return (dispatch, getStore) => {
        const {analytics} = getStore()
        dispatch(fetchAqi(analytics.aqi.location.coordinates, timestamp))
    }
}


// WEBPACK FOOTER //
// ./src/actions/analytics.js